import { FormControl } from '@mui/material';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import {
  DefaultLabel,
  StyledArrowDropDownIcon,
  StyledMenuItem,
  StyledSelect,
  selectMenuPaperPropsStyle,
} from './styles';
import { DropdownSelectFormControllerProps } from './types';

export const DropdownSelectFormController: React.FC<DropdownSelectFormControllerProps> = ({
  formControl,
  formControlName,
  label,
  selectValues,
  fullWidth = true,
  defaultValue,
  enumType = false,
  onChangeSelect,
  'data-testid': dataTestId,
  shouldRenderVoid = true,
}) => {
  const [open, setOpen] = useState(false);

  const getDefaultValues = enumType
    ? Object.entries(selectValues).map(([value, key]) => ({
        key,
        value,
      }))
    : selectValues.map((item) => ({ key: item.label, value: item.value }));

  return (
    <Controller
      name={formControlName}
      control={formControl}
      defaultValue={defaultValue}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormControl fullWidth={fullWidth}>
          <StyledSelect
            data-testid={dataTestId}
            fullWidth
            value={value || ''}
            labelId="basic-select-form-controller-v3-select-label"
            onChange={(event) => {
              onChangeSelect(event.target.value);
              onChange(event);
            }}
            displayEmpty
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            MenuProps={{
              PaperProps: selectMenuPaperPropsStyle,
            }}
            inputProps={{ 'data-testid': `select-form-controller-${formControlName}` }}
            IconComponent={() => <StyledArrowDropDownIcon onClick={() => setOpen(!open)} />}
            renderValue={(selected) => {
              const selectedOption = getDefaultValues.find((item) => item.value === selected);
              return selectedOption ? selectedOption.key : <DefaultLabel>{label}</DefaultLabel>;
            }}
          >
            {shouldRenderVoid && (
              <StyledMenuItem value="">
                <em>-</em>
              </StyledMenuItem>
            )}

            {getDefaultValues.map((item) => (
              <StyledMenuItem key={item.key} value={item.value}>
                {item.key}
              </StyledMenuItem>
            ))}
          </StyledSelect>
          <ErrorMessage>{error?.message}</ErrorMessage>
        </FormControl>
      )}
    />
  );
};
